module.exports = __webpack_public_path__ + "static/img/1.7ac18ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/1.png
// module id = cdef
// module chunks = 1